import PropTypes from "prop-types";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import token from "../../data/token.json";
import Paginator from "react-hooks-paginator";

const ProductDescriptionTab = ({ spaceBottomClass, product }) => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [review, setReview] = useState([]);
  const [shipping, setShipping] = useState([]);
  const isAuthenticated = localStorage.getItem("ID");
  const [currentPage, setCurrentPage] = useState(1);
  const pageLimit = 4;
  const [offset, setOffset] = useState(0);

  const formattedDate = new Intl.DateTimeFormat("tr-TR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(review.commentDate);

  useEffect(() => {
    getReviews();
    getShipping();
  }, [product.id]);

  const getShipping = async () => {
    const apiUrl =
      "https://api.minyatursepeti.com/api/Delivery/GetDeliveryInfo";
    try {
      await axios
        .get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => response.data)
        .then((response) => setShipping(response));
    } catch (error) {
      console.error("Veri çekme hatası:", error);
    }
  };

  const getReviews = async () => {
    const apiUrl = `https://api.minyatursepeti.com/api/Comment/${product.id}`;
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setReview(response.data);
      }
    } catch (error) {
      console.error("Veri çekme hatası:", error);
    }
  };

  const handleReview = async () => {
    try {
      const response = await fetch(
        "https://api.minyatursepeti.com/api/Comment/PostComment",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            MemberId: isAuthenticated,
            ProductId: product.id,
            Message: message,
          }),
        }
      );
      if (response.ok) {
        const responseData = await response.json();
        setError(responseData.message);
        setMessage("");
      } else {
        const responseData = await response.json();
        setError(responseData.message);
      }
    } catch (error) {
      setError("Beklenmedik bir hata oluştu.");
      console.error("Error:", error);
    }
  };

  function checkUserAuthentication() {
    const userId = localStorage.getItem("ID");
    return userId !== null;
  }

  const currentReviews = review.slice(offset, offset + pageLimit);

  const renderReviews = currentReviews.map((review, key) => (
    <div key={key} className="single-review">
      <div className="review-img" style={{ float: "left", width: "90px" }}>
        <img
          src={
            process.env.PUBLIC_URL +
            "/assets/img/logo/minyatursepetiyuvarlak.png"
          }
          alt="Minyatür Sepeti"
          style={{ width: "100%" }}
        />
      </div>
      <div className="review-content">
        <div className="review-top-wrap">
          <div className="review-left">
            <div className="review-name">
              <h4>
                {review.member.firstName +
                  " " +
                  review.member.lastName.substring(0, 1) +
                  "*".repeat(review.member.lastName.length - 1)}
              </h4>
            </div>
            <div className="review-date">
              {review.commentDate ? formattedDate : "Tarih bulunamadı"}
            </div>
          </div>
        </div>
        <div className="review-bottom">
          <p>{review.message}</p>
        </div>
      </div>
    </div>
  ));

  return (
    <div className={`description-review-area ${spaceBottomClass}`}>
      <div className="container">
        <div className="description-review-wrapper">
          <Tab.Container defaultActiveKey="productShipping">
            <Nav variant="pills" className="description-review-topbar">
              <Nav.Item>
                <Nav.Link eventKey="additionalInfo">Ek Bilgi</Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="productShipping">Teslimat Bilgisi</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="productReviews">
                  Yorumlar ({review.length})
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="description-review-bottom">
              <Tab.Pane eventKey="additionalInfo">
                <div className="product-anotherinfo-wrapper">
                  <ul>
                    <li>
                      <span>Ölçü</span>
                      {product && product.size}
                    </li>
                    <li>
                      <span>Materyal</span>
                      {product && product.material}
                    </li>
                  </ul>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="productReviews">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="review-wrapper">
                      {review && review.length > 0 ? (
                        renderReviews
                      ) : (
                        <span style={{ fontSize: "17px" }}>
                          Bu ürün hakkında yorum bulunamadı.
                        </span>
                      )}
                      {review.length > pageLimit && (
                        <div className="pro-pagination-style text-center mt-30">
                          <Paginator
                            totalRecords={review.length}
                            pageLimit={pageLimit}
                            pageNeighbours={2}
                            setOffset={setOffset}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            pageContainerClass="mb-0 mt-0"
                            pagePrevText="«"
                            pageNextText="»"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {checkUserAuthentication() ? (
                    <div className="col-lg-5">
                      <div className="ratting-form-wrapper pl-50">
                        <h3>Yorum Yap</h3>
                        <div className="ratting-form">
                          <form>
                            <div className="star-box"></div>{" "}
                            {error && (
                              <div
                                className={
                                  error ===
                                  "Yorumunuz incelenmeye alınmıştır. En kısa sürede değerlendirilip yayına alınacaktır."
                                    ? "info-message"
                                    : "error-message"
                                }
                              >
                                {error}
                              </div>
                            )}
                            <div className="row">
                              <div className="col-md-12">
                                <div className="rating-form-style form-submit">
                                  <textarea
                                    name="Your Review"
                                    placeholder="Yorumunuz"
                                    defaultValue={""}
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                  />
                                  <input
                                    value="Gönder"
                                    type="button"
                                    onClick={handleReview}
                                  />
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-lg-5">
                      <div className="ratting-form-wrapper pl-50">
                        <h3>Yorum Yap</h3>
                        <br></br>
                        <h5>
                          Yorum yapabilmek için giriş yapmanız gerekmektedir.
                        </h5>
                        <Link to={process.env.PUBLIC_URL + "/Uyelik"}>
                          Giriş Yap / Üye Ol
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="productShipping">
                {shipping.map((shipping, index) => (
                  <div key={index}>
                    {shipping.description.split("\n").map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))}
                  </div>
                ))}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

ProductDescriptionTab.propTypes = {
  productFullDesc: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};
export default ProductDescriptionTab;
